// extracted by mini-css-extract-plugin
export default {"recipeImageText":"Searched_recipeImageText__dQ39w","recipeTitle":"Searched_recipeTitle__NVdmT","recipeAboveTitleText":"Searched_recipeAboveTitleText__GhYyX"};